import React, { useState, useEffect } from "react";
import { Calendar } from "react-multi-date-picker";
import DatePanel from "react-multi-date-picker/plugins/date_panel";
import axios from "axios";
import swal from "sweetalert";
import moment from "moment";
import StarNewSchedule from "../StarNewSchedule/StarNewSchedule";

const format = "YYYY-MM-DD";

const EventSuperstarSchedule = () => {
  const [selectElement, setSelectElement] = useState(0);
  const [dates, setDates] = useState([]);
  const [newSchedule, setNewSchedule] = useState([]);
  const [schedule, setSchedule] = useState({});
  const [createForm, setCreateForm] = useState(false);
  const [selectedSchedule, setSelectedSchedule] = useState([]);
  const [pending, setPending] = useState(true);

  const handleRemoveClick = (date) => {
    const list = [...dates];
    const ar = list.filter((item) => !(item === date));

    setDates(ar);
    const scheduleList = [...newSchedule];
    const ar2 = scheduleList.filter((item) => !(item === date));
    setNewSchedule(ar2);

    setCreateForm(false);
  };

  const handleNewSchedule = (index) => {
    setSchedule(dates[index]);
    setCreateForm(true);
    getDateWiseSchedule(dates[index]);
  };

  const getDateWiseSchedule = (dates) => {
    var date = dates.year + "-" + dates.month?.number + "-" + dates.day;
    let selectedDate = moment(date).format("YYYY-MM-DD");

    axios.get(`/api/star/schedule/${selectedDate}`).then((res) => {
      if (res.status === 200) {
        setSelectedSchedule(res.data.schedule);
        // setDates(res.data.schedule)
      }
    });
  };

  function handleCheck(event, day) {
    setSelectElement(day);
    setPending(event);
  }

  return (
    <div className="container-lg">
      <h1 className="text-warning text-center ss-text mb-2 py-2 superStarHeading">
        Make SuperStar Schedule
      </h1>

      <div className="my-4 eventDatePicker d-flex justify-content-center">
        <Calendar
          value={dates}
          onChange={setDates}
          format="YYYY-MM-DD"
          multiple
          sort
          calendarPosition="bottom-center"
        />
      </div>

      <div>
        <div className="d-flex flex-wrap my-5">
          {dates.map((date, i) => {
            return (
              <div className="m-2">
                <div className="cardContainer">
                  <div className="face face1">
                    <div
                      key={i}
                      className="eventDatePicked d-flex"
                      style={
                        selectElement === date.day
                          ? {
                              background:
                                "linear-gradient(90deg, rgb(233, 138, 29) 0%, rgb(153, 108, 50) 35%, rgb(202, 238, 245) 100%)",
                            }
                          : {
                              background:
                                "linear-gradient(90deg, rgb(144, 154, 236) 0%, rgb(101, 80, 197) 35%, rgb(18, 15, 167) 100%)",
                            }
                      }
                    >
                      {/* <div className="d-flex"> */}
                      <div>
                        {date.day} {date.month.shortName}, {date.year}
                        {/* {date.format()} */}
                      </div>
                      <button
                        className="removeDatePick ms-3"
                        onClick={() => handleRemoveClick(date)}
                        type="button"
                      >
                        <i className="fas fa-times"></i>
                      </button>
                      {/* </div> */}
                    </div>
                  </div>

                  <div className="face face2">
                    <div className="content">
                      <h5 className="text-white">
                        <i className="fas fa-calendar-week mx-1"></i>{" "}
                        <span className="mx-3">Schedule</span>
                      </h5>

                      {/* <button type="button" className="mt-2" onClick={() => handleNewSchedule(i)} >Create Schedule</button> */}
                      <button
                        type="button"
                        className="mt-2"
                        onClick={() => handleNewSchedule(i)}
                      >
                        Create Schedule
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>

      {/* {newSchedule.map((schedule, i) => {
                return (
                    <>  
                      <NewSchedule schedule={schedule} id={i} onClick={handleCheck}  />
                    </>
                )
            })} */}
      {createForm == true ? (
        <>
          {" "}
          <StarNewSchedule
            schedule={schedule}
            selectedSchedule={selectedSchedule}
            onClick={handleCheck}
          />
        </>
      ) : null}
    </div>
  );
};

export default EventSuperstarSchedule;
